<template>
  <div class="presentation-page">
    <div class="presentation-page__wrapper">
      <div class="presentation-page__content">
        <slot />
      </div>
      <PresentationPageFooter :page-number="pageNumber" :page-count="pageCount" />
    </div>
  </div>
</template>

<script>
import PresentationPageFooter from '@/views/MasterPresentation/PresentationPageFooter';

export default {
  name: 'PresentationPage',

  components: {
    PresentationPageFooter,
  },

  props: {
    pageNumber: {
      type: Number,
      required: true,
    },
    pageCount: {
      type: Number,
      required: true,
    },
  },
};
</script>
